module.exports = __webpack_public_path__ + "img/our_mission.82e1f2f3.svg";